import axiosTuri from "../../axiosTuri";

// Get All Tour Titles
export const getTourTitles = async () => {
  const res = await axiosTuri.get(`tour-titles`);
  if (res.data.status == "success") {
    return res.data.data;
  }
};

// Create Private Tour
export const create_private_tour = async (data) => {
  const res = await axiosTuri.post(`create-private-tour`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Offers
export const getAllOffers = async (id) => {
  const res = await axiosTuri.get(`get-all-offers/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Offer
export const deletePrivateTour = async (offer_id) => {
  const res = await axiosTuri.delete(`delete-private-tour/${offer_id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Private Tour
export const editPrivateTour = async (data) => {
  const res = await axiosTuri.post(`edit-private-tour/${data.id}`, data.data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Private Tour
export const deleteLastDayTour = async (id) => {
  const res = await axiosTuri.delete(`delete-day-tour/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Private Tour
export const editDatePrivateTour = async (data) => {
  const res = await axiosTuri.post(
    `edit-private-tour-date/${data.id}`,
    data.data
  );
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Private Tour
export const editDayPrivateTour = async (data) => {
  const res = await axiosTuri.post(`edit-private-tour-day`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All My Offers
export const getAllMyPackages = async (id) => {
  const res = await axiosTuri.get(`get-all-my-packages/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};
